import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "label" }
const _hoisted_2 = {
  key: 1,
  class: "remind-ball"
}
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.item.field=='department_region')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", {
            class: "form-components",
            style: {"margin":"0"}
          }, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "form-components",
            style: {"margin":"0","flex":"unset"}
          }, null, -1))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["form-components", {'el-form-item is-error':_ctx.store.state.errorFileList.includes(_ctx.item.field)}])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.item.remark||_ctx.stateFieldRemark[_ctx.item.field])
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  content: _ctx.item.remark||_ctx.stateFieldRemark[_ctx.item.field],
                  "popper-class": "remark-popper",
                  placement: "top-start",
                  trigger: "click"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("img", {
                      src: "https://images.goworkla.cn/wxAppletImg/EnergyValue_result_about.png",
                      class: "label-remark"
                    }, null, -1)
                  ])),
                  _: 1,
                  __: [5]
                }, 8, ["content"]))
              : _createCommentVNode("", true),
            (_ctx.item.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.item.name), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.provience,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.provience) = $event)),
              class: "m-2",
              onChange: _ctx.provienceChange,
              disabled: _ctx.item.is_disable
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinceList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange", "disabled"]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.city,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.city) = $event)),
              class: "m-2",
              onChange: _ctx.cityChange,
              disabled: _ctx.item.is_disable
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange", "disabled"]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.county,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.county) = $event)),
              class: "m-2",
              onChange: _ctx.countyChange,
              disabled: _ctx.item.is_disable
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countyList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange", "disabled"])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}